import React from "react";
import { useUser } from "contexts/userContext/userContext.js";
import PreviewForm from "components/Pages/ProfileUser/JumboEmbed/FormManagement/PreviewForm";
const EmbedDynamicExample = ({
  selectedForm,
  previewMode,
  formInEmbedPage = null,
  hideFooter = null,
  includeTitleAndDesc = null,
  brandingColor = null,
  embedPageFormImage = "",
  embedPageEditMode = null,
  activeFormInJumboFormsPage = null,
  handleFinishUploadProcess = () => handleFinishUploadProcess,
}) => {
  const { getUserData } = useUser();
  return (
    <>
      {selectedForm && (
        <PreviewForm
          activeFormInJumboFormsPage={activeFormInJumboFormsPage}
          currentUserId={getUserData() && getUserData().UserId}
          isPreview={previewMode}
          width={selectedForm.Embed_Dynamic_Width}
          height={selectedForm.Embed_Dynamic_Height}
          formId={selectedForm.Embed_Dynamic_Id}
          formInEmbedPage={formInEmbedPage}
          embedPageFormImage={embedPageFormImage}
          embedPageEditMode={embedPageEditMode}
          hideFooter={hideFooter}
          includeTitleAndDesc={includeTitleAndDesc}
          handleFinishUploadProcess={handleFinishUploadProcess}
          brandingColor={brandingColor}
        />
      )}
    </>
  );
};

export default EmbedDynamicExample;
